<template>
  <div id="scroll-threshold-example">
    <div>
      <div class="mt-5" v-if="settings">
        <v-row :class="$vuetify.breakpoint.smAndDown?'':'mx-1'">
          <v-col cols="12">
            <v-container style="max-width:900px">
                <v-row class="px-3">
                  <v-col cols="12" md="12">
                    <div class="text-center">
                      <v-card
                        class="neu-glow py-5"        
                      >
                        <v-img v-if="!$vuetify.theme.dark"
                          :src="'/static/users/pictures/db/'+settings.options.logoDB"
                          :lazy-src="'/static/users/pictures/db/'+settings.options.logoDB"
                          max-width="250"
                          class="mx-auto"
                        >
                        </v-img>
                        <v-img v-else
                          :src="'/static/users/pictures/db/'+settings.options.logoDBW"
                          :lazy-src="'/static/users/pictures/db/'+settings.options.logoDBW"
                          max-width="250"
                          class="mx-auto"
                        >
                        </v-img>                        
                        <div>
                          <div class="text-h4 mt-3 mb-1">Coupon Omaggio</div>
                        </div>
                      </v-card>
                    </div> 
                  </v-col>
                  <v-col cols="12" v-if="!settings">
                    <v-card class="text-center neu-glow py-5">
                      <v-progress-circular indeterminate size="300" width="20" color="info"></v-progress-circular>
                    </v-card>
                  </v-col>
                  <template v-else>
                    <v-card-text>
                      <v-card class="pa-4 text-h5 neu-glow text-center">
                        <div class="mt-3">
                          <v-img
                            :src="'/static/users/pictures/coupons/'+settings.picture"
                            :lazy-src="'/static/users/pictures/coupons/'+settings.picture"
                            class="mx-auto"
                          >
                          </v-img>
                        </div>
                        <div class="mt-2" v-html="settings.couponText1"></div>
                      </v-card>
                    </v-card-text>
                    <v-card-text>
                      <v-card class="pa-4 text-h5 neu-glow text-center">
                        <p>
                          valido fino al:
                        </p>
                        <p :class="settings.expired?'error--text text-h3 font-weight-black':'success--text text-h3 font-weight-black'">{{settings.expiry}}</p>
                        <p v-if="settings.validDoW.includes(localizedDoW)&&!settings.spentDate">
                          Utilizzabile oggi: <span class="success--text text-h3 font-weight-black">SI</span>
                        </p>
                        <p v-else>
                          Utilizzabile oggi: <span class="error--text text-h3 font-weight-black">NO</span>
                        </p>
                        <p class="text-caption">
                        (Utilizzabile nei giorni: <span v-for="(d,di) in dows.filter(d => settings.validDoW.includes(d.code))" :key="di" :class="localizedDoW==d.code?'success--text text-caption':'text-caption'">
                          {{d['it'].substring(0,12).toUpperCase()}}{{(di <= dows.filter(d => settings.validDoW.includes(d.code)).length-2)?',':''}}
                        </span>)                                        
                        </p>
                      </v-card>
                    </v-card-text>
                    <v-card-text>
                      <v-card class="pa-4 neu-glow text-center" v-if="!settings.spentDate&&!settings.expired">
                        <v-row class="text-center">
                          <v-col class="d-flex justify-center">
                            <div class="px-4 pt-4 pb-2 white text-center" style="max-width:232px" @click="dialog_showPwd=!dialog_showPwd">
                              <qrcode-vue @click="dialog_showPwd=!dialog_showPwd"  value="https://ibookrestaurant.com/validateqr/?p=verification" :size="200" render-as="svg" level="L" :margin="20"></qrcode-vue>
                            </div>
                          </v-col>
                        </v-row>
                      </v-card>
                      <v-card class="pa-4 neu-glow text-center" v-else-if="settings.spentDate">
                        <v-row>
                          <v-col>
                            <div class="text-h5 warning--text">
                              Coupon già speso il <div class="text-h3 font-weight-black">{{settings.spentDate}}</div>
                            </div>
                          </v-col>
                        </v-row>
                      </v-card>
                      <v-card class="pa-4 neu-glow text-center" v-else>
                        <v-row>
                          <v-col>
                            <div class="text-h5 warning--text">
                              Coupon scaduto il <div class="text-h3 font-weight-black">{{settings.expiry}}</div>
                            </div>
                          </v-col>
                        </v-row>
                      </v-card>                                              
                    </v-card-text>
                  </template>
                </v-row>
            </v-container>
          </v-col>
        </v-row>
      </div>
    </div>
    <v-btn
      v-if="settings"
      v-scroll="onScroll"
      v-show="scrollToTop"
      fab
      dark
      small
      fixed
      bottom
      right
      :color="settings.options.color"
      @click="toTop"
    >
      <v-icon>keyboard_arrow_up</v-icon>
    </v-btn>
    <v-bottom-navigation
      color="orange"
      absolute
      hide-on-scroll
      scroll-target="#scroll-threshold-example"
      scroll-threshold="500" 
      class="mt-3 mb-4" 
      style="position:unset"
      v-if="settings"   
    >
      <v-btn :href="settings.options.facebookURL" v-if="settings.options.facebookURL">
        <span>Facebook</span>
        <v-icon color="#3b5998">mdi-facebook</v-icon>
      </v-btn>
      <v-btn :href="settings.options.instagramURL" v-if="settings.options.instagramURL">
        <span>Instagram</span>
        <v-icon color="#C13584">mdi-instagram</v-icon>
      </v-btn>
      <v-btn :href="settings.options.youtubeURL" v-if="settings.options.youtubeURL">
        <span>YouTube</span>
        <v-icon color="#c4302b">mdi-youtube</v-icon>
      </v-btn>
      <v-btn :href="settings.options.linkedInURL" v-if="settings.options.linkedInURL">
        <span>LinkedIn</span>
        <v-icon color="#0077b5">mdi-linkedin</v-icon>
      </v-btn>      
    </v-bottom-navigation>
    <div id="scroll-threshold-example">
      &nbsp;
    </div>  
    <v-dialog v-model="dialog_showPwd"
      width="460"
      class="neu-glow"
    >
      <v-card class="neu-glow-inset">
        <v-card-title class="text-h5 font-weight-bold">
          Spendi Coupon
            <v-spacer></v-spacer>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" fab icon small class="neu-glow" @click="dialog_showPwd = false">
                  <v-icon color="info">mdi-close</v-icon>
                </v-btn>
              </template>
              <span>{{$t(page+'.Close')}}</span>
            </v-tooltip>        
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="py-5 text-h6 error--text">
          Attenzione!! cliccando sul pulsante viene invalidato il coupon
        </v-card-text>
        <v-card-text>
          <!--
          <v-text-field
            :error-messages="fieldErrors('form.password').length>0?$t(page+'.'+fieldErrors('form.password')):null"
            :append-icon="showPwd ? 'mdi-eye' : 'mdi-eye-off'"
            :type="showPwd ? 'text' : 'password'"
            @input="$v.form.password.$touch()"
            @blur="$v.form.password.$touch()"
            prepend-inner-icon="vpn_key"
            placeholder="Password"
            persistent-placeholder
            v-model="form.password"
            label="Password"
            hide-details
            @click:append="showPwd = !showPwd"
            outlined
            color="info"
            class="px-6 py-2"
          />
          -->
          <div class="px-6">
            <v-btn color="error" block @click="validateQR(1)" :loading="loader"
              >Invalida Coupon
            </v-btn>
          </div>                          
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog_isValid"
      width="460"
      class="neu-glow"
      v-if="payloads"
    >
    <v-card class="neu-glow-inset">
      <v-card-title class="text-h4 mb-4 font-weight-bold">
        Coupon Speso
          <v-spacer></v-spacer>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" fab icon small class="neu-glow" @click="dialog_isValid = false">
                <v-icon color="info">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>{{$t(page+'.Close')}}</span>
          </v-tooltip>        
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="text-center mt-3">
        <v-icon color="success" style="font-size:180px">mdi-check-circle-outline</v-icon>
      </v-card-text>
    </v-dialog>

    <v-dialog v-model="dialog_isNotValid"
      width="460"
      class="neu-glow"
      v-if="payloads"
    >
    <v-card class="neu-glow-inset">
      <v-card-title class="text-h4 mb-4 font-weight-bold">
        Errore
          <v-spacer></v-spacer>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" fab icon small class="neu-glow" @click="dialog_isNotValid = false">
                <v-icon color="info">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>{{$t(page+'.Close')}}</span>
          </v-tooltip>        
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="text-center mt-3">
        <v-icon color="error" style="font-size:180px">mdi-close-circle-outline</v-icon>
      </v-card-text>      
      <v-card-text class="mt-4">
        <div class="text-h5" v-if="payloads.emailError">
          Email Errata
        </div>          
        <div class="text-h5" v-else>
          Email errata, <br>
          Coupon scaduto o già speso
        </div>        
      </v-card-text>
    </v-card>
    </v-dialog>    
    <v-snackbar v-model="snackbar.active"
      top
      timeout="2000"
      class=""
      :color="snackbar.color"
    >
      {{snackbar.text}}
    </v-snackbar>    
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import QrcodeVue from 'qrcode.vue'
import { required, minLength } from "vuelidate/lib/validators";
import validationMixin from "@/mixins/validationMixin";
const defaultForm = {
  password: "",
};
export default {
  mixins: [validationMixin],
  validations: {
    form: {
      password: {
        required,
        minLength: minLength(6),
      },
    },
  },
  validationMessages: {
    form: {
      password: {
        required: "Please enter password",
        minLength: "Password must be of 6 characters",
      },
    },
  },
   components: {
      QrcodeVue,
    },
  data() {
    return {
      page: "Review",
      wHeight: window.innerHeight,
      wWidth: window.innerWidth,
      dialog_thanks:false,
      dialog_leave_to_tripadvisor:false,
      dialog_connection_error:false,
      dialog_leave_to_tripadvisor:false,
      dialog_duplicated:false,
      dialog_showPwd:false,
      dialog_isValid:false,
      dialog_isNotValid:false,
      loading:false,
      form: Object.assign({}, defaultForm),
      origin:null,
      date:null,//new Date().toISOString().substring(0,10),
      today:new Date().toISOString().substring(0,10),
      locale:'it',   
      snackbar:{active:false,color:'success',text:''},
      reviewSaved:false,
      uu:null,
      user:{},
      booking:{firstName:null,lastName:null},
      bookingId:null,
      totalScore:0,
      coupon:null,
      partialScore:0,
      review:{"food":5,"service":5,"value":5,"location":5,"review":null},
      settings:null,
      reviewPrizeValidUntil:null,
      QRCodeLink:'https://ibookrestaurant.com/coupon/?p=A6978BB7FF5A980CA71783D56AFC7F28CAF0EE3F8313F04C6687591369FDCA6716F0C29DA894810C1C06A59DD444842007203796D744BC035926342291C6D369',
      payloads:null,
      hostname:null,
      locale:null,
      dows:[
            {code:1,it:'Lunedì',en:'Mondays'},
            {code:2,it:'Martedì',en:'Tuesdays'},
            {code:3,it:'Mercoledì',en:'Wednsdays'},
            {code:4,it:'Giovedì',en:'Thursdays'},
            {code:5,it:'Venerdì',en:'Fridays'},
            {code:6,it:'Sabato',en:'Saturdays'},
            {code:7,it:'Domenica',en:'Sundays'}
           ],      
    };
  },
  created(){
    this.$vuetify.theme.dark=true;
    //localStorage.removeItem('uu');
    sessionStorage.removeItem('jwt');
    const la=window.navigator.userLanguage||window.navigator.language;
    this.$store.dispatch("setLocale",la.substring(0,2));
    this.locale=la.substring(0,2);
    this.couponId=this.$route.query.p;
    console.log(818,this.$route,this.$route.query,this.$route.query.p);
    this.origin=this.$route.path;
    console.log(347,this.origin);
    var hostname=window.location.hostname;
    this.QRCodeLink='https://'+hostname+'/qrcodevalidate/?p='+this.couponId
    this.Authenticate(this.couponId)

  },  
  mounted: function () {

  },
  computed : {
    ...mapGetters(["settings","countries"]),
    localizedDoW: function()
    {
      var z=new Date().getDay();
      console.log(368,z);
      //z=z==0?7:0;
      console.log(370,z)
      return z;
    }    
  },
  watch : {
  },
  methods:
  {
    async validateQR(v)
    {
      this.loading=true;
      this.form.couponId=this.couponId;
      this.form.validate=v;
      let payload={"action":'validateQR',"payload":this.form}
      console.log(1259,payload)
      let w= await this.updateDB(payload)
      console.log(992,w,w.errorid);
      this.loading=false;
      this.dialog_showPwd=false;
      console.log(1075,w)
      this.payloads=w;
      if(w.errorid=='0')
      {
        console.log(1078,w)
        //if (this.payloads.isValid)
        this.dialog_isValid=1
        //else this.dialog_isNotValid=1
      }
      else
      {
        this.dialog_isNotValid=1
      }
    },    
    addDaysFormatted(days) {
      var result = new Date();
      result.setDate(result.getDate() + days);
      return result.toLocaleDateString( this.settings.locale,{ weekday: 'long',  month: 'long', day: 'numeric' });
    },        
    onScroll (e) {
      if (typeof window === 'undefined') return
      const top = window.pageYOffset ||   e.target.scrollTop || 0
      this.scrollToTop = top > 20
    },
    toTop () {
      this.$vuetify.goTo(0)
    },
    async Authenticate(couponId){
      this.loading=true;
      //try{
          const payload=JSON.stringify({"action":"AuthenticateCoupon","payload":{"couponId":couponId}});
          const res = await this.$http.post('/review/review.php', payload );
          console.log(1026,res);
          switch (res.data.errorid)
          {
            case '0':
              sessionStorage.setItem('jwt', res.data.jwt);
              this.settings=res.data.payloads;
              //this.coupon=res.data.payloads;
              console.log(374,this.settings)              
            break;
            case '0001':

            break
            case '0006':
              this.$router.push('/auth/login').catch(() => {});
            break;
          }
          this.loading= false;
      /*} catch(e)
      {
          this.dialog_connection_error=true;
          console.error(1215,e);
      }*/
    },
    async updateDB(payload){
      try{
          const res = await this.$http.post('/review/review.php', payload);
          console.log(1284,res);
          if (res.data.errorid=='0')
          {
            sessionStorage.setItem('jwt', res.data.jwt);
          }
          else
          {
            console.log(1291);
            //this.$router.push('/auth/login').catch(() => {});
          }
          return res.data;
      } catch(e)
      {
        this.dialog_connection_error=true;
        console.log(e);
      }
    },    
  },
};
</script>
